import React from "react";

import { IgLink, IgTypography } from "@intelligems/ig-theme";
import Grid from "@mui/material/Grid";
import { msa } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

export const getSubscriptionMsa = (
  version: "onboarding" | "settings",
  customContent
) => {
  return (
    <Grid sx={{ marginTop: 4 }}>
      {version === "settings" ? (
        <IgTypography>
          By clicking above, you agree to our{"  "}
          <IgLink
            onClick={() => {
              openNewTab(msa);
            }}
          >
            terms
          </IgLink>
        </IgTypography>
      ) : (
        <IgTypography>
          By clicking {!customContent ? "above" : customContent}, you hereby
          agree to the{"  "}
          <IgLink
            onClick={() => {
              openNewTab(msa);
            }}
          >
            Intelligems SaaS Agreement
          </IgLink>
          .
        </IgTypography>
      )}
    </Grid>
  );
};
